import React from "react";
import { BrandMark } from "./BrandMark";
import { Link } from "react-router-dom";
import { FiArrowUpRight } from "react-icons/fi";

const Footer: React.FC = () => (
  <footer className="handle-site-footer">
    <div className="handle-site-footer-inner">
      <div className="handle-footer-brand">
        <BrandMark className="handle-footer-mark" decorative />
        <div>
          <strong>Build with permission.</strong>
          <span>Your data. Your terms. Your upside.</span>
        </div>
      </div>
      <nav aria-label="Footer links">
        <Link to="/connections">Sources</Link>
        <Link to="/evidence">Receipts & subscriptions</Link>
        <Link to="/marketplace">Marketplace</Link>
        <Link to="/developers">Developers <FiArrowUpRight size={12}/></Link>
      </nav>
      <span className="handle-footer-copy">© {new Date().getFullYear()} Handle · A new data economy, built on consent.</span>
    </div>
  </footer>
);

export default Footer;
